import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'context/ThemeContext';
import { PODCAST_PROVIDER_MAP } from 'shared/data/podcastProviders';
import { Button } from '../Button/Button';
import { SOCIALS_MAP } from 'shared/data/socialMedia';
import { hasPublishedEpisodes } from 'shared/utils/getEpisode';

const LINK_COLUMNS = [
  {
    titleKey: 'footer.social' as const,
    links: Object.values(SOCIALS_MAP),
  },
  {
    titleKey: 'footer.listen' as const,
    links: Object.values(PODCAST_PROVIDER_MAP),
  },
  // {
  //   title: 'Editorial',
  //   links: [
  //     { label: 'Newsletter', href: '#' },
  //     { label: 'Media Kit', href: '#' },
  //   ],
  // },
  // {
  //   title: 'Legal',
  //   links: [
  //     { label: 'Privacy', href: '#' },
  //     { label: 'Terms', href: '#' },
  //   ],
  // },
];

export function Footer() {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();

  const linkColumns = hasPublishedEpisodes() ? LINK_COLUMNS : [LINK_COLUMNS[0]]

  return (
    <footer className="bg-surface-container-lowest w-full py-12 md:py-20 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row justify-between items-start gap-12">
        {/* Brand */}
        <div className="max-w-md">
          <Link to="/" className="flex items-center gap-3 mb-4">
            <img
              src="/ms-icon-310x310.png"
              alt={t('podcast.title')}
              className="w-10 h-10 rounded-full"
            />
            <span className="font-serif italic text-tertiary text-3xl">
              {t('podcast.title')}
            </span>
          </Link>
          <p className="font-sans text-sm font-light text-on-surface-variant/70 leading-relaxed">
            {t('podcast.blurb')}
          </p>
        </div>

        {/* Link Columns */}
        <div className="grid grid-cols-2 sm:grid-cols-2 gap-x-12 gap-y-8 mr-12">
          {linkColumns.map((column) => {
            return (
              <div key={column.titleKey}>
                <span className="col-span-2 font-sans text-xs uppercase tracking-widest text-tertiary font-bold">
                  {t(column.titleKey)}
                </span>
                <div className="flex flex-col gap-4 mt-4">
                  {column.links.map((link) => (
                    <a
                      key={link.label}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-sans text-sm font-light text-on-surface-variant/70 hover:text-tertiary transition-all"
                    >
                      {link.label}
                      <span className="sr-only">{t('a11y.opensInNewTab')}</span>
                    </a>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Copyright + Theme Toggle (dev only) */}
      {process.env.NODE_ENV === 'development' && (
        <div className="max-w-7xl mx-auto mt-12 pt-12 border-t border-outline-variant/10 flex items-center justify-between">
          <Button
            variant="link"
            size="sm"
            icon={theme === 'dark' ? 'sun' : 'moon'}
            onClick={toggleTheme}
            aria-label={t('footer.toggleTheme')}
            className="text-on-surface-variant/50 hover:text-tertiary font-light"
          >
            <span className="hidden sm:inline">{theme === 'dark' ? t('footer.lightMode') : t('footer.darkMode')}</span>
          </Button>
        </div>
      )}
    </footer>
  );
}
